import { render, staticRenderFns } from "./GroupSessionPresenterInvitationNotification.vue?vue&type=template&id=06738f0c&scoped=true&"
import script from "./GroupSessionPresenterInvitationNotification.vue?vue&type=script&lang=js&"
export * from "./GroupSessionPresenterInvitationNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06738f0c",
  null
  
)

export default component.exports